import LegalLayout from "./LegalLayout";

export default function TermsOfUse() {
  return (
    <LegalLayout title="Conditions d'utilisation" updated="23 juillet 2026">
      <p>Bienvenue sur le site de <strong>Délices Mikaté Royal</strong>.</p>
      <p>
        En consultant ou en utilisant le site{" "}
        <a href="https://www.mikateroyal.com" target="_blank" rel="noreferrer">www.mikateroyal.com</a>,
        vous acceptez les présentes conditions d&apos;utilisation. Si vous n&apos;acceptez pas ces
        conditions, veuillez ne pas utiliser le site.
      </p>

      <h2>1. Utilisation du site</h2>
      <p>Le site de Délices Mikaté Royal permet aux visiteurs de&nbsp;:</p>
      <ul>
        <li>découvrir nos produits&nbsp;;</li>
        <li>consulter nos offres&nbsp;;</li>
        <li>effectuer des demandes d&apos;information&nbsp;;</li>
        <li>effectuer des commandes lorsque cette fonctionnalité est disponible.</li>
      </ul>
      <p>L&apos;utilisateur s&apos;engage à utiliser le site de manière légale et responsable.</p>

      <h2>2. Exactitude des informations</h2>
      <p>
        Délices Mikaté Royal fait des efforts raisonnables pour maintenir les informations présentées
        sur son site à jour.
      </p>
      <p>Toutefois, certaines informations peuvent être modifiées sans préavis, notamment&nbsp;:</p>
      <ul>
        <li>les prix&nbsp;;</li>
        <li>la disponibilité des produits&nbsp;;</li>
        <li>les descriptions&nbsp;;</li>
        <li>les offres promotionnelles.</li>
      </ul>

      <h2>3. Commandes et transactions</h2>
      <p>Toute commande effectuée sur le site est soumise aux&nbsp;:</p>
      <p>
        <a href="/conditions-generales-vente">Conditions générales de vente</a>
      </p>
      <p>ainsi qu&apos;aux politiques applicables de Délices Mikaté Royal.</p>
      <p>
        Le client est responsable de fournir des informations exactes lors de toute demande ou commande.
      </p>

      <h2>4. Propriété intellectuelle</h2>
      <p>Tout le contenu présent sur le site, incluant notamment&nbsp;:</p>
      <ul>
        <li>textes&nbsp;;</li>
        <li>images&nbsp;;</li>
        <li>logos&nbsp;;</li>
        <li>éléments graphiques&nbsp;;</li>
        <li>photos de produits&nbsp;;</li>
        <li>marques et contenus promotionnels</li>
      </ul>
      <p>appartient à Délices Mikaté Royal ou est utilisé avec autorisation.</p>
      <p>
        Toute reproduction, modification ou utilisation commerciale du contenu sans autorisation écrite
        préalable est interdite.
      </p>

      <h2>5. Utilisation des images et contenus</h2>
      <p>Les images présentées sur le site servent à illustrer nos produits.</p>
      <p>
        La présentation réelle des produits peut varier légèrement en raison de leur fabrication
        artisanale.
      </p>

      <h2>6. Liens vers des sites externes</h2>
      <p>Le site peut contenir des liens vers des services ou sites externes.</p>
      <p>
        Délices Mikaté Royal n&apos;est pas responsable du contenu, de la sécurité ou des pratiques de
        confidentialité de ces sites externes.
      </p>

      <h2>7. Disponibilité du site</h2>
      <p>Nous faisons des efforts raisonnables pour maintenir le site accessible.</p>
      <p>
        Cependant, nous ne pouvons garantir une disponibilité continue sans interruption, notamment en
        cas de maintenance, de problème technique ou d&apos;événement indépendant de notre volonté.
      </p>

      <h2>8. Limitation de responsabilité</h2>
      <p>Délices Mikaté Royal ne peut être tenu responsable des dommages résultant&nbsp;:</p>
      <ul>
        <li>d&apos;une mauvaise utilisation du site&nbsp;;</li>
        <li>d&apos;informations incorrectes fournies par l&apos;utilisateur&nbsp;;</li>
        <li>d&apos;une interruption temporaire du service&nbsp;;</li>
        <li>de circonstances indépendantes de notre contrôle.</li>
      </ul>

      <h2>9. Protection des renseignements personnels</h2>
      <p>
        La collecte et l&apos;utilisation des renseignements personnels sont régies par notre&nbsp;:
      </p>
      <p>
        <a href="/politique-confidentialite">Politique de confidentialité</a>
      </p>

      <h2>10. Modifications des conditions d&apos;utilisation</h2>
      <p>
        Délices Mikaté Royal se réserve le droit de modifier ces conditions d&apos;utilisation à tout
        moment.
      </p>
      <p>La version publiée sur le site est celle applicable au moment de votre utilisation.</p>

      <h2>11. Contact</h2>
      <p>
        <strong>Délices Mikaté Royal</strong><br />
        Site Web&nbsp;: <a href="https://www.mikateroyal.com" target="_blank" rel="noreferrer">www.mikateroyal.com</a><br />
        Courriel&nbsp;: <a href="mailto:contact@mikateroyal.com">contact@mikateroyal.com</a>
      </p>
    </LegalLayout>
  );
}
